import React from "react";

const JotformIntegrationIcon = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", Object.assign({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  ref: svgRef
}, props, {
  className: "transform-gpu " + (props.className || "")
}), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_368_506)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M6.59634 17.241C6.90574 17.541 6.68707 18.0549 6.24772 18.0549H3.49809C2.95559 18.0549 2.51416 17.627 2.51416 17.101V14.4355C2.51416 14.0096 3.04428 13.7976 3.35369 14.0976L6.59634 17.241Z",
  fill: "#0A1551"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.8942 17.4485C10.0803 16.6399 10.0803 15.3289 10.8942 14.5203L13.8316 11.6021C14.6455 10.7935 15.9651 10.7935 16.779 11.6021C17.5929 12.4107 17.5929 13.7217 16.779 14.5303L13.8416 17.4485C13.0277 18.2571 11.7082 18.2571 10.8942 17.4485Z",
  fill: "#FFB629"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3.13472 10.1158C2.32082 9.30723 2.32082 7.99624 3.13472 7.18765L8.078 2.27312C8.89189 1.46452 10.2115 1.46452 11.0254 2.27312C11.8393 3.08172 11.8393 4.39272 11.0254 5.20133L6.08212 10.1158C5.26821 10.9244 3.94862 10.9244 3.13472 10.1158Z",
  fill: "#0099FF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.17561 13.6185C6.36171 12.8099 6.36171 11.4989 7.17561 10.6903L13.8549 4.05458C14.6688 3.24599 15.9883 3.24599 16.8022 4.05458C17.6162 4.86319 17.6162 6.17418 16.8022 6.98277L10.123 13.6185C9.30911 14.4271 7.98951 14.4271 7.17561 13.6185Z",
  fill: "#FF6100"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_368_506"
}, /*#__PURE__*/React.createElement("rect", {
  width: 14.9718,
  height: 16.6667,
  fill: "white",
  transform: "translate(2.51416 1.66667)"
}))));

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(JotformIntegrationIcon, Object.assign({
  svgRef: ref
}, props)));
export default ForwardRef;